import ViewMessage from "./ViewMessage";

export default ViewMessage